import { type CreateReceiptUploadInput, ReceiptUploadStatus } from 'API';

export class CreateReceiptInput implements CreateReceiptUploadInput {
  id?: string | null | undefined;
  paidolId: string;
  authPaidolId: string;
  document: string;
  status: ReceiptUploadStatus;
  highnoteTransactionEventId?: string | null | undefined;
  reimbursementTransactionId?: string | null | undefined;
  /** SEE-1598: the uploaded file's own name, shown in the receipt pane and renamable. */
  displayName?: string | null | undefined;
  /** SEE-1601: the stored file's size in bytes, shown per split in the split editor. */
  sizeBytes?: number | null | undefined;

  constructor(
    document: string,
    paidolId: string,
    highnoteTransactionEventId?: string | null,
    reimbursementTransactionId?: string | null,
    displayName?: string | null,
    sizeBytes?: number | null
  ) {
    this.paidolId = paidolId;
    this.authPaidolId = paidolId;
    this.document = document;
    this.status = ReceiptUploadStatus.PENDING;
    this.highnoteTransactionEventId = highnoteTransactionEventId;
    this.reimbursementTransactionId = reimbursementTransactionId;
    this.displayName = displayName ?? undefined;
    this.sizeBytes = sizeBytes && sizeBytes > 0 ? Math.round(sizeBytes) : undefined;
  }
}
